import React from 'react';
import { connect } from 'react-redux';
import objectAssign from 'object-assign';
import { Container, Icon } from 'semantic-ui-react';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import CenterPanel from './centerPanel';
import CenterPanelGC from './centerPanelGC';
import PageHeader from '../../header';
import {
  selectWaitingArea,
  getWaitingArea,
  resetWaitingArea,
  updateWaitingAreaSearch,
  showAdvancedMenu,
  updateSelectedVideoCallRoomId,
  getConsultNowInitiatedCalls,
} from '../../../../actions/waitingArea';
import { showShowCallHistoryModal } from '../../../../actions/modal';
import WaitingAreasViewOneModalsContainer from '../../../../containers/WaitingAreasViewOneModalsContainer';
import ParticipantModal from '../pariticipant/content';
import ConfirmationCallMessageModal from '../confirmation-call-message/content';
import NotifyRoomParticipant from '../notifyRoomParticipant/content';
import CallHistoryContentContainer from '../../../../containers/WaitingAreaCallHistoryModal';
import { previousPage as previousPageAction } from 'actions/navigationBar';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import { Media } from '../../../../mediaSetting';

const CallTypeEnum = {
  WA: 'WAITINGAREA',
  CN: 'CONSULTNOW',
};

@connect(mapStateToProps)
export default class ViewOneWaitingArea extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      waitingAreaRoomsFiltered: [],
      consultNowRoomsFiltered: [],
      id: props.id,
      waitingAreaRoomsGray: [],
      activeTabItem: APP.LANGUAGE.ViewOneWaitingArea.MainWaitingArea,
    };
  }

  UNSAFE_componentWillMount() {
    // select this waiting area and fetch the waiting area from server
    this.props.dispatch(selectWaitingArea(this.state.id));
    queueESEvents(
      ESEventTypes.APICall,
      `In view-one page UNSAFE_componentWillMount: ${this.state.id}`,
      'eventType&apiURL',
      {
        apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + this.state.id + '/calls',
        browserURL: window.location.href,
      },
      null,
      true,
      'info'
    );
    this.props.dispatch(getWaitingArea(this.state.id));
    // When leaving this page the menu should close
    this.props.dispatch(showAdvancedMenu(false));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetchingWaitingArea === true && this.props.fetchingWaitingArea === false) {
      if (this.props.waitingArea && this.props.waitingArea.rooms && this.props.waitingArea.rooms.length > 0) {
        // When that's there are Consult Now call then make the selection of Consult Now tab enabled
        if (
          this.props.waitingArea.rooms.some((room) => room.callSource == CallTypeEnum.CN) &&
          this.props.waitingArea.isConsultNowEnabled === true
        ) {
          this.setState({
            activeTabItem: APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase(),
          });
        }
      }
      // TODO-HH for MVP+
      // Currently it only fetches initatedCalls api when isConsultNowEnabled is true, that means it has to wait for flag be returned in /waitingareas/id/calls api
      // for MVP+, we can make isConsultNowEnabled to be returned before /waitingareas/id/calls api is call, so that we don't need to call initatedCalls api after waiting for /waitingareas/id/calls api
      if (this.props.waitingArea.isConsultNowEnabled === true) {
        // Check if isConsultNowEnabled is true, then need to fetch initiated calls for Consult Now
        let cb = (result, data, err) => {
          if (data && Array.isArray(data)) {
            if (data.length > 0) {
              // If initiated calls has more than 1 call, set Consult Now tab enabled by default
              this.setState({
                activeTabItem: APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase(),
              });
              // Subscribe to Consult Now authTickets
              // let readyForSubscribeCN = data.map(each => PUBNUB_CHANNELS.CONSULT_NOW + each.authTicketId);
              // subscribePubnubChannels(readyForSubscribeCN);
            }
          }
        };
        this.props.dispatch(getConsultNowInitiatedCalls(this.state.id, cb));
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //START this code is to apply filters when data is being retrieved
    let dontSetState = true;
    // Depending on isConsultNowEnabled's value, it will either need to filter by callSource or not
    // if isConsultNowEnabled is false, all Consult Now call will be treated as normal WA calls
    let nextPropsWARooms = nextProps.waitingArea.isConsultNowEnabled
      ? nextProps.waitingArea.rooms.filter((room) => room.callSource == CallTypeEnum.WA)
      : nextProps.waitingArea.rooms;
    let resultOffilterTwo = this.waitingAreaRoomFilterSearch(
      nextPropsWARooms,
      dontSetState,
      nextProps.currentWaitingAreaFilter
    );
    let filteredAndGrayMeetingRooms = {
      waitingAreaRoomsGray: resultOffilterTwo.waitingAreaRoomsGray || [],
      waitingAreaRoomsFiltered: resultOffilterTwo.waitingAreaRoomsFiltered || [],
    };
    // update component local state
    this.setState({
      waitingAreaRoomsFiltered: filteredAndGrayMeetingRooms.waitingAreaRoomsFiltered,
      waitingAreaRoomsGray: filteredAndGrayMeetingRooms.waitingAreaRoomsGray,
    });
  }

  componentWillUnmount() {
    this.props.dispatch(resetWaitingArea());
    this.props.dispatch(updateWaitingAreaSearch(''));
    this.props.dispatch(updateSelectedVideoCallRoomId(null));
    this.props.dispatch(showShowCallHistoryModal(false));
  }

  waitingAreaRoomFilterSearch = (waitingAreaRooms, dontSetState, currentFilter) => {
    let waitingAreasToFilter = waitingAreaRooms || [];
    let smartQuery = null;
    // TODO-HH: Handle Calls shift when toggled Consult Now
    if (currentFilter.indexOf('¤') > -1) {
      let splitted = currentFilter.split('¤');
      smartQuery = (object) => {
        if (object[splitted[0]]) {
          if (object[splitted[0]].toLowerCase() == splitted[1].toLowerCase()) {
            return true;
          } else return false;
        } else {
          return false;
        }
      };
    }
    let containsSearchExpression = (waitingArea) => {
      return (
        (
          waitingArea.mainParticipant.name.toLowerCase() +
          (waitingArea.mainParticipant.phone ? waitingArea.mainParticipant.phone.toLowerCase() : '') +
          waitingArea.mainParticipant.status.toLowerCase()
        ).indexOf(currentFilter.toLowerCase()) > -1
      );
      if (waitingArea.mainParticipant) {
        return true;
      } else {
        return false;
      }
    };
    let filtered = waitingAreasToFilter.filter(smartQuery || containsSearchExpression);

    let differenceBetweenArrays = waitingAreasToFilter.filter(function (obj) {
      return !filtered.some(function (obj2) {
        return obj.name == obj2.name;
      });
    });

    if (!dontSetState)
      this.setState({
        waitingAreaRoomsGray: differenceBetweenArrays,
        waitingAreaRoomsFiltered: filtered,
      });
    else
      return {
        waitingAreaRoomsGray: differenceBetweenArrays,
        waitingAreaRoomsFiltered: filtered,
      };
  };

  handleTabClick = (e, { name }) => {
    // Reset Cog Menu if it opened
    if (this.props.showAdvancedMenu) this.props.dispatch(showAdvancedMenu(false));
    this.setState({ activeTabItem: name });
  };

  render() {
    const { waitingArea } = this.props;
    let modals = '';
    // Participant workflow
    let participantModal = '';
    let notifyParticpantModal = '';
    let callHistoryModal = '';
    let confirmationCallMessModal = '';

    if (
      this.props.showViewWaitingAreaParticipantModal &&
      this.props.selectedParticipant &&
      waitingArea.rooms.find((o) => o.participants.find((oo) => oo.id == this.props.selectedParticipant.id)) != null
    ) {
      participantModal = (
        <ParticipantModal
          participantCanDisconnect={this.props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1}
          participantFormData={this.props.selectedParticipant}
        />
      );
    }
    if (this.props.showNotifyRoomParticipantModal && this.props.selectedVideoCallRoom) {
      notifyParticpantModal = (
        <NotifyRoomParticipant
          showNotifyRoomParticipantModal={this.props.showNotifyRoomParticipantModal}
          participantRoomData={this.props.selectedVideoCallRoom}
        />
      );
    }
    if (this.props.showCallHistoryModal && waitingArea.rooms) {
      // When there is no call activity (disconnect / refresh), then hide the modal until there's new history coming
      callHistoryModal = (
        <CallHistoryContentContainer
          showCallHistoryModal={this.props.showCallHistoryModal && waitingArea.rooms.length > 0}
          timezone={this.props.timezone}
        />
      );
    }

    modals = (
      <WaitingAreasViewOneModalsContainer
        waitingArea={this.props.waitingArea}
        consultNowInitiatedRoomsFiltered={this.props.consultNowInitiatedRoomsFiltered}
        consultNowRoomsFiltered={this.props.consultNowRoomsFiltered}
        dispatch={this.props.dispatch}
      />
    );

    let bottomSession = (
      <AccordionSession
        isConsultNowEnabled={this.props.isConsultNowEnabled}
        activeTabItem={this.state.activeTabItem}
        waitingArea={this.props.waitingArea}
        userId={this.props.userId}
        timezones={this.props.timezones}
        dispatch={this.props.dispatch}
      />
    );

    let linkClass = () => {
      if (!this.props.fetchingWaitingArea) {
        return this.props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && this.props.hasWaitingAreaAccess
          ? 'color-waiting-area-text'
          : 'back-to-org-link';
      }
      return 'hide';
    };
    if (this.props.showConfirmationCallMessModal) {
      // When there is no call activity (disconnect / refresh), then hide the modal until there's new history coming
      confirmationCallMessModal = (
        <ConfirmationCallMessageModal
          showConfirmationCallMessage={this.props.showConfirmationCallMessModal}
          dispatch={this.props.dispatch}
          callerSuccessAction={this.props.confirmationCallSuccessAction}
          callParticipants={this.props.callParticipants}
          actionType={this.props.confirmationCallMessActionType}
        />
      );
    }

    let isThisGroupConsultation = this.props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation;

    let actionButtonText = () => {
      return this.props.waitingAreaRoomsFiltered.length > 0
        ? otherProviderIsInCall()
          ? APP.LANGUAGE.ViewOneWaitingArea.JoinCallGC
          : isThereAnyIdleRoom()
          ? APP.LANGUAGE.ViewOneWaitingArea.JoinIdleGC
          : APP.LANGUAGE.ViewOneWaitingArea.StartCallGC
        : APP.LANGUAGE.ViewOneWaitingArea.WaitingForCallers;
    };

    let otherProviderIsInCall = () => {
      if (this.props.waitingAreaRoomsFiltered.length > 0) {
        let roomBeingSeen = this.props.waitingAreaRoomsFiltered.filter((room) => {
          return room.statusId == APP.LANGUAGE.MessageCodes.StatusAttendedCode;
        });

        if (!roomBeingSeen || roomBeingSeen.length === 0) {
          return false;
        }

        let otherProviders = roomBeingSeen[0].participants.filter(
          (participant) => participant.canAnswerCall === true && participant.participantStatus === 'A'
        );

        return otherProviders.length > 0;
      }

      return false;
    };

    let isThereAnyIdleRoom = () => {
      if (this.props.waitingAreaRoomsFiltered.length > 0) {
        let roomIdle = this.props.waitingAreaRoomsFiltered.filter((room) => {
          return room.statusId == APP.LANGUAGE.MessageCodes.StatusIdleCode;
        });

        return roomIdle && roomIdle.length > 0;
      }

      return false;
    };

    /* Can Start/Join GC Call */
    let canStartGCCall = () => {
      return (
        !this.props.isCurrentUserInCall &&
        this.props.waitingAreaRoomsFiltered.length > 0 &&
        this.props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1
      );
    };

    /* Start/Join GC Call */
    let startGCCall = () => {
      if (!canStartGCCall()) {
        return;
      }

      let callscreenUrl =
        window.APP.CONFIGURATION.CURRENT_VCC_PAGE +
        'ce/?apikey=' +
        this.props.waitingArea.orgAPIKey +
        '&nid=' +
        this.props.waitingArea.id;
      window.open(
        callscreenUrl,
        null,
        'width=' +
          (screen.width - 20) +
          ',height=' +
          (screen.height - 100) +
          ', left=0, top=0, scrollbars=yes,status=yes'
      );
    };

    // calculates the color for the waiting room rows
    let calculateColor = (status, minutes) => {
      let color = '';

      if (
        status == APP.LANGUAGE.ViewOneWaitingArea.Idle ||
        (minutes >= window.APP.CONFIGURATION.EscalationOfWaitingFromOrangeIntoRed &&
          status != APP.LANGUAGE.ViewOneWaitingArea.Attended)
      )
        color = 'waiting-area-red';
      else if (status == APP.LANGUAGE.ViewOneWaitingArea.Waiting) color = 'waiting-area-orange';
      else if (status == APP.LANGUAGE.ViewOneWaitingArea.Attended) color = 'waiting-area-pill';
      return color;
    };

    // load caller row template when fetching waiting area rooms
    let loadCallerRowTemplate = () => {
      return [{}, {}].map((o, i) => {
        return (
          <div className="row flexible row-hoverable " key={i}>
            {i == 0 ? (
              <div className="ui active inverted dimmer">
                <div className="ui text loader pdtxl mrtl " />
              </div>
            ) : (
              <div className="ui active inverted dimmer" />
            )}
            <div className="column status-column bold hide-on-small-ress" style={{ width: '25%' }}>
              <div className="max-width span-like left-text color-gray-bg color-gray">asd</div>
              <div className="right-text pdrs max-width span-like color-gray-bg color-gray">
                <span>asd</span>
              </div>
            </div>
            <div
              className=" left-column-fixed column bold show-on-small-ress flex-like center-flex"
              style={{ width: '50%', fontSize: '0.94rem' }}
            >
              <div className="mrlm mrtm color-gray-bg color-gray" style={{ width: '80%' }}>
                asdasdasd
              </div>
            </div>
            <Container
              fluid
              as={Media}
              greaterThanOrEqual="tablet"
              className="right-column-fixed"
              style={{ width: '65%' }}
            >
              <div className="column pdlnull inline-flex" style={{ width: '61.5%' }}>
                <div className="color-gray-bg color-gray left-text">asdasdasdasd</div>
              </div>
              <div className="column pdlnull inline-flex" style={{ width: '38.5%' }}>
                <div className="color-gray-bg color-gray right-text">asdasdasdasd</div>
              </div>
            </Container>
            <Container fluid as={Media} at="mobile" className="right-column-fixed" style={{ width: '50%' }}>
              <div className="column pdlm inline-flex center-flex">
                <div>
                  <div className="color-gray-bg color-gray mrbxxs" style={{ fontSize: '0.92rem' }}>
                    asdasdasdasd
                  </div>
                  <div className="color-gray-bg color-gray" style={{ fontSize: '0.92rem' }}>
                    asdasdasdasd
                  </div>
                </div>
              </div>
            </Container>
            <div className="right-column-fixed column pdlxs hide-on-small-ress center-text" style={{ width: '10%' }}>
              <span className="color-gray-bg color-gray">asdas</span>
            </div>
          </div>
        );
      });
    };

    return (
      <div className="main-ui-container waiting-area-view-one new-waiting-area-view-one">
        <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
          <div className="left-hand-side-panel">
            <div className="relative mrrm">
              <PageHeader
                classes="waiting-area-title"
                isCombinedTitle={true}
                titlePart1={this.props.waitingArea.name ? this.props.waitingArea.name : '\u00A0'}
                titlePart2={this.props.waitingArea.name ? ' ' + APP.LANGUAGE.ViewOneWaitingArea.Title : ''}
                titleColor="color-waiting-area-text"
                subHeaderClass="waiting-area-sub-title"
                subHeader={this.props.waitingArea.organisationName}
                notRenderLogo={true}
                linkTo={
                  this.props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title &&
                  this.props.hasWaitingAreaAccess
                    ? `/waiting-area/view-all`
                    : `/organisational-unit/view-all`
                }
                linkText={
                  this.props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title &&
                  this.props.hasWaitingAreaAccess
                    ? APP.LANGUAGE.ViewOneWaitingArea.BackToWaitingAreasLinkText
                    : APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                }
                linkClass={linkClass()}
                linkOnClick={() => {
                  this.props.dispatch(previousPageAction(window.APP.LANGUAGE.ViewOneWaitingArea.Title));
                }}
                renderActionButtons={isThisGroupConsultation}
                actionButtonText={isThisGroupConsultation ? actionButtonText() : ''}
                actionButtonStyle={
                  isThisGroupConsultation
                    ? {
                        backgroundColor: canStartGCCall() ? '#0C5192' : '#E4E9ED',
                        borderRadius: '4px',
                      }
                    : ''
                }
                /* Action button is enabled only when Group Consulation feature is enabled, User is not in GC Call, There are callers waiting */
                actionButtonClass={
                  isThisGroupConsultation
                    ? 'ui icon button icon ' + (canStartGCCall() ? ' color-white' : ' disable')
                    : ''
                }
                actionButtonOnClick={() => {
                  startGCCall();
                }}
                showSubHeaderTag={isThisGroupConsultation}
                subHeaderTagText={isThisGroupConsultation ? APP.LANGUAGE.EntityAdmin.GroupConsultation : ''}
              >
                <span>
                  <img
                    className="ui image  mrrnull fl pdrs header-icon"
                    src={
                      this.props.waitingArea.networkTypeId !== NetworkTypes.GroupConsultation
                        ? APP.IMAGES.WaitingAreaIcon.default
                        : APP.IMAGES.GCWaitingAreaIcon.default
                    }
                  />
                </span>
              </PageHeader>
            </div>
            <div className="pdlm pdrl">
              {this.props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
                <CenterPanelGC
                  waitingArea={this.props.waitingArea}
                  fetchingWaitingArea={this.props.fetchingWaitingArea}
                  timezone={this.props.timezone}
                  waitingAreaRoomsGray={this.state.waitingAreaRoomsGray}
                  waitingAreaRoomsFiltered={this.state.waitingAreaRoomsFiltered}
                  currentWaitingAreaFilter={this.props.currentWaitingAreaFilter}
                  selectedVideoCallRoomId={this.props.selectedVideoCallRoomId}
                  handleJoinCallClick={startGCCall}
                  calculateColor={calculateColor}
                  loadCallerRowTemplate={loadCallerRowTemplate}
                />
              ) : (
                <CenterPanel
                  isConsultNowEnabled={this.props.isConsultNowEnabled}
                  handleTabClick={this.handleTabClick}
                  activeTabItem={this.state.activeTabItem}
                  waitingArea={this.props.waitingArea}
                  fetchingWaitingArea={this.props.fetchingWaitingArea}
                  timezone={this.props.timezone}
                  waitingAreaRoomsGray={this.state.waitingAreaRoomsGray}
                  waitingAreaRoomsFiltered={this.state.waitingAreaRoomsFiltered}
                  consultNowRoomsFiltered={this.props.consultNowRoomsFiltered}
                  consultNowInitiatedRoomsFiltered={this.props.consultNowInitiatedRoomsFiltered}
                  currentWaitingAreaFilter={this.props.currentWaitingAreaFilter}
                  consultNowInitiatedWaitingAreasFilter={this.props.consultNowInitiatedWaitingAreasFilter}
                  consultNowInporgressWaitingAreasFilter={this.props.consultNowInporgressWaitingAreasFilter}
                  selectedVideoCallRoomId={this.props.selectedVideoCallRoomId}
                  calculateColor={calculateColor}
                  loadCallerRowTemplate={loadCallerRowTemplate}
                  dispatch={this.props.dispatch}
                />
              )}
            </div>
          </div>
          <div className="right-hand-side-panel color-right-hand-side-panel-bg">
            <RightPanelOrTopPanel
              isConsultNowEnabled={this.props.isConsultNowEnabled}
              activeTabItem={this.state.activeTabItem}
              waitingArea={this.props.waitingArea}
              fetchingWaitingArea={this.props.fetchingWaitingArea}
              bottomSession={bottomSession}
              showAdvancedMenu={this.props.showAdvancedMenu}
              isAdmin={this.props.isAdmin}
              dispatch={this.props.dispatch}
              previousPage={this.props.previousPage}
              hasWaitingAreaAccess={this.props.hasWaitingAreaAccess}
              actionButtonText={isThisGroupConsultation ? actionButtonText() : ''}
              actionButtonStyle={
                isThisGroupConsultation
                  ? {
                      backgroundColor: canStartGCCall() ? '#0C5192' : '#E4E9ED',
                      borderRadius: '4px',
                    }
                  : ''
              }
              /* Action button is enabled only when Group Consulation feature is enabled, User is not in GC Call, There are callers waiting */
              actionButtonClass={
                isThisGroupConsultation ? 'ui icon button icon ' + (canStartGCCall() ? ' color-white' : ' disable') : ''
              }
              actionButtonOnClick={() => {
                startGCCall();
              }}
            />
          </div>
        </Container>
        <Container fluid as={Media} lessThan="computer">
          <div className="left-hand-side-panel-mobile">
            <PageHeader
              classes="waiting-area-title"
              isCombinedTitle={true}
              titlePart1={this.props.waitingArea.name ? this.props.waitingArea.name : '\u00A0'}
              titlePart2={this.props.waitingArea.name ? ' ' + APP.LANGUAGE.ViewOneWaitingArea.Title : ''}
              titleColor="color-waiting-area-text"
              subHeaderClass="waiting-area-sub-title"
              subHeader={this.props.waitingArea.organisationName}
              notRenderLogo={true}
              linkTo={
                this.props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && this.props.hasWaitingAreaAccess
                  ? `/waiting-area/view-all`
                  : `/organisational-unit/view-all`
              }
              linkText={
                this.props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && this.props.hasWaitingAreaAccess
                  ? APP.LANGUAGE.ViewOneWaitingArea.BackToWaitingAreasLinkText
                  : APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
              }
              linkClass={linkClass()}
              linkOnClick={() => {
                this.props.dispatch(previousPageAction(window.APP.LANGUAGE.ViewOneWaitingArea.Title));
              }}
              renderActionButtons={isThisGroupConsultation}
              actionButtonText={isThisGroupConsultation ? actionButtonText() : ''}
              actionButtonStyle={
                isThisGroupConsultation
                  ? {
                      backgroundColor: canStartGCCall() ? '#0C5192' : '#E4E9ED',
                      borderRadius: '4px',
                    }
                  : ''
              }
              /* Action button is enabled only when Group Consulation feature is enabled, User is not in GC Call, There are callers waiting */
              actionButtonClass={
                isThisGroupConsultation ? 'ui icon button icon ' + (canStartGCCall() ? ' color-white' : ' disable') : ''
              }
              actionButtonOnClick={() => {
                startGCCall();
              }}
              showSubHeaderTag={isThisGroupConsultation}
              subHeaderTagText={isThisGroupConsultation ? APP.LANGUAGE.EntityAdmin.GroupConsultation : ''}
            >
              <span>
                <img
                  className="ui image  mrrnull fl pdrs header-icon"
                  src={
                    this.props.waitingArea.networkTypeId !== NetworkTypes.GroupConsultation
                      ? APP.IMAGES.WaitingAreaIcon.default
                      : APP.IMAGES.GCWaitingAreaIcon.default
                  }
                />
              </span>
            </PageHeader>
            <div className="right-hand-side-panel-mobile">
              <RightPanelOrTopPanel
                isConsultNowEnabled={this.props.isConsultNowEnabled}
                activeTabItem={this.state.activeTabItem}
                fetchingWaitingArea={this.props.fetchingWaitingArea}
                waitingArea={this.props.waitingArea}
                isAdmin={this.props.isAdmin}
                bottomSession={bottomSession}
                showAdvancedMenu={this.props.showAdvancedMenu}
                dispatch={this.props.dispatch}
                previousPage={this.props.previousPage}
                hasWaitingAreaAccess={this.props.hasWaitingAreaAccess}
                actionButtonText={isThisGroupConsultation ? actionButtonText() : ''}
                actionButtonStyle={
                  isThisGroupConsultation
                    ? {
                        backgroundColor: canStartGCCall() ? '#0C5192' : '#E4E9ED',
                        borderRadius: '4px',
                      }
                    : ''
                }
                /* Action button is enabled only when Group Consulation feature is enabled, User is not in GC Call, There are callers waiting */
                actionButtonClass={
                  isThisGroupConsultation
                    ? 'ui icon button icon ' + (canStartGCCall() ? ' color-white' : ' disable')
                    : ''
                }
                actionButtonOnClick={() => {
                  startGCCall();
                }}
              />
            </div>
            <div>
              {this.props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
                <CenterPanelGC
                  waitingArea={this.props.waitingArea}
                  fetchingWaitingArea={this.props.fetchingWaitingArea}
                  timezone={this.props.timezone}
                  waitingAreaRoomsGray={this.state.waitingAreaRoomsGray}
                  waitingAreaRoomsFiltered={this.state.waitingAreaRoomsFiltered}
                  currentWaitingAreaFilter={this.props.currentWaitingAreaFilter}
                  selectedVideoCallRoomId={this.props.selectedVideoCallRoomId}
                  handleJoinCallClick={startGCCall}
                  calculateColor={calculateColor}
                  loadCallerRowTemplate={loadCallerRowTemplate}
                />
              ) : (
                <CenterPanel
                  isConsultNowEnabled={this.props.isConsultNowEnabled}
                  handleTabClick={this.handleTabClick}
                  activeTabItem={this.state.activeTabItem}
                  waitingArea={this.props.waitingArea}
                  fetchingWaitingArea={this.props.fetchingWaitingArea}
                  timezone={this.props.timezone}
                  waitingAreaRoomsGray={this.state.waitingAreaRoomsGray}
                  waitingAreaRoomsFiltered={this.state.waitingAreaRoomsFiltered}
                  consultNowRoomsFiltered={this.props.consultNowRoomsFiltered}
                  consultNowInitiatedRoomsFiltered={this.props.consultNowInitiatedRoomsFiltered}
                  currentWaitingAreaFilter={this.props.currentWaitingAreaFilter}
                  consultNowInitiatedWaitingAreasFilter={this.props.consultNowInitiatedWaitingAreasFilter}
                  consultNowInporgressWaitingAreasFilter={this.props.consultNowInporgressWaitingAreasFilter}
                  selectedVideoCallRoomId={this.props.selectedVideoCallRoomId}
                  calculateColor={calculateColor}
                  loadCallerRowTemplate={loadCallerRowTemplate}
                />
              )}
            </div>
            {!!this.props.waitingArea.operatingHours && !!this.props.waitingArea.supportSetting ? (
              <div className="mrtl right-hand-side-bottom-on-mobile">
                {bottomSession}
                <BottomLogo waitingArea={this.props.waitingArea} dispatch={this.props.dispatch} />
              </div>
            ) : (
              ''
            )}
          </div>
        </Container>
        {modals}
        {participantModal}
        {notifyParticpantModal}
        {callHistoryModal}
        {confirmationCallMessModal}
      </div>
    );
  }
}

function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;

  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);

  let hasWaitingAreaAccess = () => {
    let userProfile = state.usersReducer.userProfile;

    if (
      userProfile &&
      userProfile.hasEntityAdminRights &&
      userProfile.hasEntityAdminRights.isOrgAdmin &&
      userProfile.shouldLoadDirectlyAssociatedWAs
    ) {
      return userProfile.hasDirectlyAssociatedWaitingAreas;
    }

    return userProfile.hasWaitingAreas;
  };

  // In case isConsultNowEnabled is turned off, all related Consult Now call will fall to normal WA calls
  let waitingAreaRoomsFiltered = waitingArea.rooms;
  let consultNowRoomsFiltered = [];
  let consultNowInitiatedRoomsFiltered = [];

  if (waitingArea && waitingArea.isConsultNowEnabled) {
    waitingAreaRoomsFiltered = waitingArea.rooms.filter((room) => room.callSource == CallTypeEnum.WA);
    // Consult Now In progress calls
    consultNowRoomsFiltered = waitingArea.rooms.filter((room) => room.callSource == CallTypeEnum.CN);
    // Consult Now Initiated calls
    consultNowInitiatedRoomsFiltered = waitingArea.initatedCalls || []; // added empty array if no initiated rooms available
  }

  return {
    waitingArea: waitingArea,
    isConsultNowEnabled: waitingArea.isConsultNowEnabled,
    fetchingWaitingArea: state.waitingAreaReducer.fetchingWaitingArea,
    waitingAreaRoomsFiltered: waitingAreaRoomsFiltered,
    consultNowRoomsFiltered: consultNowRoomsFiltered,
    consultNowInitiatedRoomsFiltered: consultNowInitiatedRoomsFiltered,
    currentWaitingAreaFilter: state.waitingAreaReducer.currentWaitingAreaFilter,
    consultNowInitiatedWaitingAreasFilter: state.waitingAreaReducer.consultNowInitiatedWaitingAreasFilter,
    consultNowInporgressWaitingAreasFilter: state.waitingAreaReducer.consultNowInporgressWaitingAreasFilter,
    isAdmin: state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin,
    hasWaitingAreaAccess: hasWaitingAreaAccess(),
    showAdvancedMenu: state.waitingAreaReducer.showAdvancedMenu,
    userId: state.usersReducer.userProfile.id,
    timezone: state.usersReducer.userProfile.timezoneOffsetNow,
    timezones: state.usersReducer.timezones,
    showViewWaitingAreaParticipantModal: state.modalReducer.showViewWaitingAreaParticipantModal,
    showAddToCallWaitingAreaModal: state.modalReducer.showAddToCallWaitingAreaModal,
    showNotifyRoomParticipantModal: state.modalReducer.showNotifyRoomParticipantModal,
    showCallHistoryModal: state.modalReducer.showCallHistoryModal,
    selectedParticipant: state.waitingAreaReducer.selectedParticipantForm,
    selectedVideoCallRoom: state.waitingAreaReducer.selectedVideoCallRoomForm,
    selectedVideoCallRoomId: state.waitingAreaReducer.selectedVideoCallRoomId,
    previousPage: state.navigationBarReducer.previousPage,
    confirmationCallSuccessAction: state.modalReducer.confirmationCallMessSuccessAction,
    showConfirmationCallMessModal: state.modalReducer.showConfirmationCallMessModal,
    callParticipants: state.modalReducer.callParticipants,
    confirmationCallMessActionType: state.modalReducer.confirmationCallMessActionType,
    isGroupConsultationFeatureEnabled: state.usersReducer.isGroupConsultationFeatureEnabled,
    isCurrentUserInCall: state.usersReducer.isInCall,
    isCurrentUserInGCCall: state.usersReducer.isInGCCall,
  };
}
